/**
 * Delete OAuth Connection Schema
 *
 * DELETE /api/oauth/connection/:connectionId
 * Removes a specific OAuth connection by ID (multi-account safe)
 */

import { z } from "zod";

/**
 * Path variables for deleting a connection
 */
export const DeleteConnectionPathVarsSchema = z.object({
  connectionId: z.string().uuid()
});

/**
 * Response for deleting a connection
 * Carries an explicit success flag inside the ApiSuccess data envelope.
 */
export const DeleteConnectionResponseSchema = z.object({ success: z.boolean() });
